module.exports = __webpack_public_path__ + "static/media/passo-1.cc0caa7c.png";